import { IAnnotationAttachment } from 'src/app/model/thingie/annotation';
import { IDownloadableAttachment } from './downloadable-attachment';

/**
 * Downloadable attachment, which has not been saved yet
 */
export interface ITemporaryAttachment extends IDownloadableAttachment {

  /**
   * The file to add/represented by this attachment
   */
  file: File;
}

/**
 * Type-guard for {@link ITemporaryAttachment}
 *
 * Check if given attachment is a temporary attachment
 *
 * @param val The attachment to check
 * @returns `true` if attachment is a temporary attachment, false otherwise
 */
export function isTemporaryAttachment(val: IAnnotationAttachment): val is ITemporaryAttachment {
  return 'file' in val && val.file instanceof File;
}
